import originalGeoJsonData from "../data/geojson/worldGeoJSON.json";

export const mainColorDark = "rgb(60, 60, 60)";
export const mainColorLight = "rgb(88, 88, 90)";

export const countriesListObj = {
  AR: "Argentina",
  PL: "Poland",
  BR: "Brazil",
  ES: "Spain",
  ID: "Indonesia",
  DE: "Germany",
  DK: "Denmark",
  IN: "India",
  GL: "Greenland",
  ET: "Ethiopia",
  IR: "Iran",
  RU: "Russia",
  FR: "France",
  DZ: "Algeria",
  TD: "Chad",
  TZ: "Tanzania",
  CU: "Cuba",
  GB: "United Kingdom",
  SA: "Saudi Arabia",
  MX: "Mexico",
  IT: "Italy",
  SY: "Syria",
  LY: "Libya",
  AE: "United Arab Emirates",
  EG: "Egypt",
  TR: "Turkey",
  AU: "Australia",
  SO: "Somalia",
  YE: "Yemen",
  PT: "Portugal",
  PY: "Paraguay",
  RO: "Romania",
  ZA: "South Africa",
  VE: "Venezuela",
  CR: "Costa Rica",
  GR: "Greece",
  CO: "Colombia",
  JP: "Japan",
  PF: "French Polynesia",
  AF: "Afghanistan",
  MR: "Mauritania",
  PE: "Peru",
  PH: "Philippines",
  CK: "Cook Islands",
  NG: "Nigeria",
  LT: "Lithuania",
  CN: "China",
  KZ: "Kazakhstan",
  IS: "Iceland",
  IQ: "Iraq",
  QA: "Qatar",
  MA: "Morocco",
  FI: "Finland",
  EC: "Ecuador",
  BO: "Bolivia",
  GG: "Guernsey",
  NO: "Norway",
  NZ: "New Zealand",
  KW: "Kuwait",
  PK: "Pakistan",
  CL: "Chile",
  PA: "Panama",
  SC: "Seychelles",
  CH: "Switzerland",
  MN: "Mongolia",
  EE: "Estonia",
  MG: "Madagascar",
  KE: "Kenya",
  CV: "Cape Verde",
  JO: "Jordan",
  LK: "Sri Lanka",
  NL: "Netherlands",
  MV: "Maldives",
  GU: "Guam",
  SE: "Sweden",
  UZ: "Uzbekistan",
  BS: "Bahamas",
  UY: "Uruguay",
  MM: "Myanmar",
  GQ: "Equatorial Guinea",
  CG: "Republic of the Congo",
  PR: "Puerto Rico",
  BE: "Belgium",
  IL: "Israel",
  NA: "Namibia",
  VC: "Saint Vincent and the Grenadines",
  PG: "Papua New Guinea",
  DO: "Dominican Republic",
  AM: "Armenia",
  TM: "Turkmenistan",
  ER: "Eritrea",
  SD: "Sudan",
  NI: "Nicaragua",
  PW: "Palau",
  BY: "Belarus",
  CM: "Cameroon",
  BH: "Bahrain",
  AZ: "Azerbaijan",
  BG: "Bulgaria",
  SB: "Solomon Islands",
  MD: "Moldova",
  LA: "Laos",
  GT: "Guatemala",
  CD: "Democratic Republic of the Congo",
  TH: "Thailand",
  CF: "Central African Republic",
  BA: "Bosnia and Herzegovina",
  GM: "Gambia",
  BD: "Bangladesh",
  RS: "Serbia",
  BT: "Bhutan",
  KG: "Kyrgyzstan",
  KH: "Cambodia",
  GE: "Georgia",
  VU: "Vanuatu",
  MZ: "Mozambique",
  LB: "Lebanon",
  HU: "Hungary",
  AO: "Angola",
  GN: "Guinea",
  NP: "Nepal",
  VN: "Vietnam",
  UA: "Ukraine",
  MY: "Malaysia",
  TN: "Tunisia",
  SN: "Senegal",
  FJ: "Fiji",
  BF: "Burkina Faso",
  CZ: "Czech Republic",
  KI: "Kiribati",
  CI: "Côte d'Ivoire",
  HR: "Croatia",
  AT: "Austria",
  BN: "Brunei",
  MH: "Marshall Islands",
  ZW: "Zimbabwe",
  BI: "Burundi",
  BJ: "Benin",
  TL: "Timor-Leste",
  KR: "South Korea",
  GF: "French Guiana",
  NC: "New Caledonia",
  DM: "Dominica",
  HT: "Haiti",
  VG: "British Virgin Islands",
  IE: "Ireland",
  SI: "Slovenia",
  DJ: "Djibouti",
  KP: "North Korea",
  KY: "Cayman Islands",
  VI: "U.S. Virgin Islands",
  GY: "Guyana",
  TW: "Taiwan",
  MW: "Malawi",
  ZM: "Zambia",
  CX: "Christmas Island",
  FM: "Micronesia",
  AI: "Anguilla",
  CC: "Cocos (Keeling) Islands",
  GW: "Guinea-Bissau",
  EH: "Western Sahara",
  LV: "Latvia",
  IO: "British Indian Ocean Territory",
  NE: "Niger",
  ML: "Mali",
  SK: "Slovakia",
  OM: "Oman",
  TJ: "Tajikistan",
  YT: "Mayotte",
  SV: "El Salvador",
  UG: "Uganda",
  BQ: "Caribbean Netherlands",
  WS: "Samoa",
  AS: "American Samoa",
  TO: "Tonga",
  TV: "Tuvalu",
  GA: "Gabon",
  LC: "Saint Lucia",
  GI: "Gibraltar",
  RW: "Rwanda",
  AL: "Albania",
  XK: "Kosovo",
  HN: "Honduras",
  BW: "Botswana",
  MF: "Saint Martin",
  BB: "Barbados",
  CW: "Curaçao",
  UM: "United States Minor Outlying Islands",
  WF: "Wallis and Futuna",
  GH: "Ghana",
  HK: "Hong Kong",
  JM: "Jamaica",
  KM: "Comoros",
  IM: "Isle of Man",
  TC: "Turks and Caicos Islands",
  JE: "Jersey",
  PS: "Palestinian Territory",
  SR: "Suriname",
  SS: "South Sudan",
  SZ: "Eswatini",
  BM: "Bermuda",
  CY: "Cyprus",
  GD: "Grenada",
  GP: "Guadeloupe",
  TG: "Togo",
  SL: "Sierra Leone",
  LU: "Luxembourg",
  MO: "Macau",
  MT: "Malta",
  MQ: "Martinique",
  LS: "Lesotho",
  PM: "Saint Pierre and Miquelon",
  FK: "Falkland Islands",
  NR: "Nauru",
  NU: "Niue",
  NF: "Norfolk Island",
  MK: "North Macedonia",
  SG: "Singapore",
  BZ: "Belize",
  TT: "Trinidad and Tobago",
  RE: "Réunion",
  ME: "Montenegro",
  SX: "Sint Maarten",
  ST: "São Tomé and Principe",
  AW: "Aruba",
  SH: "Saint Helena, Ascension and Tristan da Cunha",
  KN: "Saint Kitts and Nevis",
  LR: "Liberia",
  MP: "Northern Mariana Islands",
  MU: "Mauritius",
  AG: "Antigua and Barbuda",
  FO: "Faroe Islands",
  CA_AB: "Alberta, Canada",
  CA_BC: "British Columbia, Canada",
  CA_MB: "Manitoba, Canada",
  CA_NB: "New Brunswick, Canada",
  CA_NL: "Newfoundland and Labrador, Canada",
  CA_NT: "Northwest Territories, Canada",
  CA_NS: "Nova Scotia, Canada",
  CA_NU: "Nunavut, Canada",
  CA_ON: "Ontario, Canada",
  CA_PE: "Prince Edward Island, Canada",
  CA_QC: "Quebec, Canada",
  CA_SK: "Saskatchewan, Canada",
  CA_YT: "Yukon, Canada",
  US_AL: "Alabama, USA",
  US_AK: "Alaska, USA",
  US_AZ: "Arizona, USA",
  US_AR: "Arkansas, USA",
  US_CA: "California, USA",
  US_CO: "Colorado, USA",
  US_CT: "Connecticut, USA",
  US_DE: "Delaware, USA",
  US_DC: "District of Columbia, USA",
  US_FL: "Florida, USA",
  US_GA: "Georgia, USA",
  US_HI: "Hawaii, USA",
  US_ID: "Idaho, USA",
  US_IL: "Illinois, USA",
  US_IN: "Indiana, USA",
  US_IA: "Iowa, USA",
  US_KS: "Kansas, USA",
  US_KY: "Kentucky, USA",
  US_LA: "Louisiana, USA",
  US_ME: "Maine, USA",
  US_MD: "Maryland, USA",
  US_MA: "Massachusetts, USA",
  US_MI: "Michigan, USA",
  US_MN: "Minnesota, USA",
  US_MS: "Mississippi, USA",
  US_MO: "Missouri, USA",
  US_MT: "Montana, USA",
  US_NE: "Nebraska, USA",
  US_NV: "Nevada, USA",
  US_NH: "New Hampshire, USA",
  US_NJ: "New Jersey, USA",
  US_NM: "New Mexico, USA",
  US_NY: "New York, USA",
  US_NC: "North Carolina, USA",
  US_ND: "North Dakota, USA",
  US_OH: "Ohio, USA",
  US_OK: "Oklahoma, USA",
  US_OR: "Oregon, USA",
  US_PA: "Pennsylvania, USA",
  US_RI: "Rhode Island, USA",
  US_SC: "South Carolina, USA",
  US_SD: "South Dakota, USA",
  US_TN: "Tennessee, USA",
  US_TX: "Texas, USA",
  US_UT: "Utah, USA",
  US_VT: "Vermont, USA",
  US_VA: "Virginia, USA",
  US_WA: "Washington, USA",
  US_WV: "West Virginia, USA",
  US_WI: "Wisconsin, USA",
  US_WY: "Wyoming, USA",
};

export function handleGeoJSON() {
  let data = originalGeoJsonData;

  data.features = data.features
    .filter((feature) => {
      let modifiedIsoString = feature.properties.iso.replace(/-/g, "_");
      return countriesListObj.hasOwnProperty(modifiedIsoString);
    })
    .map((feature) => {
      let modifiedIsoString = feature.properties.iso.replace(/-/g, "_");
      feature.properties.name = countriesListObj[modifiedIsoString];
      return feature;
    });

  return data;
}

export const isoLatLong = {
  AF: "33.0,65.0",
  AL: "41.0,20.0",
  XK: "42.6026,20.9020",
  DZ: "28.0,3.0",
  AS: "-14.3333,-170.0",
  AD: "42.5,1.6",
  AO: "-12.5,18.5",
  AI: "18.25,-63.1667",
  AG: "17.05,-61.8",
  AR: "-34.0,-64.0",
  AM: "40.0,45.0",
  AW: "12.5,-69.9667",
  AU: "-27.0,133.0",
  AT: "47.3333,13.3333",
  AZ: "40.5,47.5",
  BS: "24.25,-76.0",
  BH: "26.0,50.55",
  BD: "24.0,90.0",
  BB: "13.1667,-59.5333",
  BY: "53.0,28.0",
  BE: "50.8333,4.0",
  BZ: "17.25,-88.75",
  BJ: "9.5,2.25",
  BM: "32.3333,-64.75",
  BT: "27.5,90.5",
  BO: "-17.0,-65.0",
  BA: "44.0,18.0",
  BW: "-22.0,24.0",
  BR: "-10.0,-55.0",
  IO: "-6.0,71.5",
  BN: "4.5,114.6667",
  BG: "43.0,25.0",
  BF: "13.0,-2.0",
  BI: "-3.5,30.0",
  KH: "13.0,105.0",
  CM: "6.0,12.0",
  CA: "60.0,-95.0",
  CV: "16.0,-24.0",
  KY: "19.5,-80.5",
  CF: "7.0,21.0",
  TD: "15.0,19.0",
  CL: "-30.0,-71.0",
  CN: "35.0,105.0",
  CX: "-10.5,105.6667",
  CC: "-12.5,96.8333",
  CO: "4.0,-72.0",
  KM: "-12.1667,44.25",
  CG: "-1.0,15.0",
  CD: "0.0,25.0",
  CK: "-21.2333,-159.7667",
  CR: "10.0,-84.0",
  CI: "8.0,-5.0",
  HR: "45.1667,15.5",
  CU: "21.5,-80.0",
  CY: "35.0,33.0",
  CZ: "49.75,15.5",
  DK: "56.0,10.0",
  DJ: "11.5,43.0",
  DM: "15.4167,-61.3333",
  DO: "19.0,-70.6667",
  EC: "-2.0,-77.5",
  EG: "27.0,30.0",
  SV: "13.8333,-88.9167",
  GQ: "2.0,10.0",
  ER: "15.0,39.0",
  EE: "59.0,26.0",
  ET: "8.0,38.0",
  FK: "-51.75,-59.0",
  FO: "62.0,-7.0",
  FJ: "-18.0,175.0",
  FI: "64.0,26.0",
  FR: "46.0,2.0",
  GF: "4.0,-53.0",
  PF: "-15.0,-140.0",
  GA: "-1.0,11.75",
  GM: "13.4667,-16.5667",
  GE: "42.0,43.5",
  DE: "51.0,9.0",
  GH: "8.0,-2.0",
  GI: "36.1833,-5.3667",
  GR: "39.0,22.0",
  GL: "72.0,-40.0",
  GD: "12.1167,-61.6667",
  GP: "16.25,-61.5833",
  GU: "13.4667,144.7833",
  GT: "15.5,-90.25",
  GG: "49.5,-2.56",
  GN: "11.0,-10.0",
  GW: "12.0,-15.0",
  GY: "5.0,-59.0",
  HT: "19.0,-72.4167",
  HN: "15.0,-86.5",
  HK: "22.25,114.1667",
  HU: "47.0,20.0",
  IS: "65.0,-18.0",
  IN: "20.0,77.0",
  ID: "-5.0,120.0",
  IR: "32.0,53.0",
  IQ: "33.0,44.0",
  IE: "53.0,-8.0",
  IM: "54.23,-4.55",
  IL: "31.5,34.75",
  IT: "42.8333,12.8333",
  JM: "18.25,-77.5",
  JP: "36.0,138.0",
  JE: "49.21,-2.13",
  JO: "31.0,36.0",
  KZ: "48.0,68.0",
  KE: "1.0,38.0",
  KI: "1.4167,173.0",
  KP: "40.0,127.0",
  KR: "37.0,127.5",
  KW: "29.3375,47.6581",
  KG: "41.0,75.0",
  LA: "18.0,105.0",
  LV: "57.0,25.0",
  LB: "33.8333,35.8333",
  LS: "-29.5,28.5",
  LR: "6.5,-9.5",
  LY: "25.0,17.0",
  LT: "56.0,24.0",
  LU: "49.75,6.1667",
  MO: "22.1667,113.55",
  MK: "41.8333,22.0",
  MG: "-20.0,47.0",
  MW: "-13.5,34.0",
  MY: "2.5,112.5",
  MV: "3.25,73.0",
  ML: "17.0,-4.0",
  MT: "35.8333,14.5833",
  MH: "9.0,168.0",
  MQ: "14.6667,-61.0",
  MR: "20.0,-12.0",
  MU: "-20.2833,57.55",
  YT: "-12.8333,45.1667",
  MX: "23.0,-102.0",
  FM: "6.9167,158.25",
  MD: "47.0,29.0",
  MN: "46.0,105.0",
  ME: "42.0,19.0",
  MS: "16.75,-62.2",
  MA: "32.0,-5.0",
  MZ: "-18.25,35.0",
  MM: "22.0,98.0",
  NA: "-22.0,17.0",
  NR: "-0.5333,166.9167",
  NP: "28.0,84.0",
  NL: "52.5,5.75",
  NC: "-21.5,165.5",
  NZ: "-41.0,174.0",
  NI: "13.0,-85.0",
  NE: "16.0,8.0",
  NG: "10.0,8.0",
  NU: "-19.0333,-169.8667",
  NF: "-29.0333,167.95",
  MP: "15.2,145.75",
  NO: "62.0,10.0",
  OM: "21.0,57.0",
  PK: "30.0,70.0",
  PW: "7.5,134.5",
  PS: "32.0,35.25",
  PA: "9.0,-80.0",
  PG: "-6.0,147.0",
  PY: "-23.0,-58.0",
  PE: "-10.0,-76.0",
  PH: "13.0,122.0",
  PL: "52.0,20.0",
  PT: "39.5,-8.0",
  PR: "18.25,-66.5",
  QA: "25.5,51.25",
  RE: "-21.1,55.6",
  RO: "46.0,25.0",
  RU: "60.0,100.0",
  RW: "-2.0,30.0",
  SH: "-15.9333,-5.7",
  KN: "17.3333,-62.75",
  LC: "13.8833,-61.1333",
  PM: "46.8333,-56.3333",
  VC: "13.25,-61.2",
  WS: "-13.5833,-172.3333",
  SM: "43.7667,12.4167",
  ST: "1.0,7.0",
  SA: "25.0,45.0",
  SN: "14.0,-14.0",
  RS: "44.0,21.0",
  SC: "-4.5833,55.6667",
  SL: "8.5,-11.5",
  SG: "1.3667,103.8",
  SK: "48.6667,19.5",
  SI: "46.0,15.0",
  SB: "-8.0,159.0",
  SO: "10.0,49.0",
  ZA: "-29.0,24.0",
  SS: "8.0,30.0",
  ES: "40.0,-4.0",
  LK: "7.0,81.0",
  SD: "15.0,30.0",
  SR: "4.0,-56.0",
  SZ: "-26.5,31.5",
  SE: "62.0,15.0",
  CH: "47.0,8.0",
  SY: "35.0,38.0",
  TW: "23.5,121.0",
  TJ: "39.0,71.0",
  TZ: "-6.0,35.0",
  TH: "15.0,100.0",
  TL: "-8.55,125.5167",
  TG: "8.0,1.1667",
  TK: "-9.0,-172.0",
  TO: "-20.0,-175.0",
  TT: "11.0,-61.0",
  TN: "34.0,9.0",
  TR: "39.0,35.0",
  TM: "40.0,60.0",
  TC: "21.75,-71.5833",
  TV: "-8.0,178.0",
  UG: "1.0,32.0",
  UA: "49.0,32.0",
  AE: "24.0,54.0",
  GB: "54.0,-2.0",
  US: "38.0,-97.0",
  UM: "19.2833,166.6",
  UY: "-33.0,-56.0",
  UZ: "41.0,64.0",
  VU: "-16.0,167.0",
  VE: "8.0,-66.0",
  VN: "16.0,106.0",
  VG: "18.5,-64.5",
  VI: "18.3333,-64.8333",
  WF: "-13.3,-176.2",
  EH: "24.5,-13.0",
  YE: "15.0,48.0",
  ZM: "-15.0,30.0",
  ZW: "-20.0,30.0",
  SX: "18.0425,-63.0548",
  BQ: "12.1781,-68.2385",
  MF: "18.0708,-63.0501",
  CW: "12.1696,-68.9900",
  SS: "6.8770,31.3070",
  "CA-AB": "53.9333,-116.5765",
  "CA-BC": "53.7267,-127.6476",
  "CA-MB": "49.8951,-97.1384",
  "CA-NB": "46.5653,-66.4619",
  "CA-NL": "53.1355,-57.6604",
  "CA-NS": "44.6820,-63.7443",
  "CA-ON": "51.2538,-85.3232",
  "CA-PE": "46.5107,-63.4168",
  "CA-QC": "52.9399,-73.5491",
  "CA-SK": "52.9399,-106.4509",
  "CA-NT": "64.8255,-124.8457",
  "CA-NU": "70.2998,-83.1076",
  "CA-YT": "64.2823,-135.0000",
  "US-AK": "61.3850,-152.2683",
  "US-AL": "32.7990,-86.8073",
  "US-AR": "34.9513,-92.3809",
  "US-AZ": "33.7712,-111.3877",
  "US-CA": "36.1700,-119.7462",
  "US-CO": "39.0646,-105.3272",
  "US-CT": "41.5834,-72.7622",
  "US-DE": "39.3498,-75.5148",
  "US-FL": "27.8333,-81.7170",
  "US-GA": "32.9866,-83.6487",
  "US-HI": "21.1098,-157.5311",
  "US-IA": "42.0046,-93.2140",
  "US-ID": "44.2394,-114.5103",
  "US-IL": "40.3363,-89.0022",
  "US-IN": "39.8647,-86.2604",
  "US-KS": "38.5111,-96.8005",
  "US-KY": "37.6690,-84.6514",
  "US-LA": "31.1801,-91.8749",
  "US-MA": "42.2373,-71.5314",
  "US-MD": "39.0724,-76.7902",
  "US-ME": "44.6074,-69.3977",
  "US-MI": "43.3504,-84.5603",
  "US-MN": "45.7326,-93.9196",
  "US-MO": "38.4623,-92.3020",
  "US-MS": "32.7673,-89.6812",
  "US-MT": "46.9048,-110.3261",
  "US-NC": "35.6411,-79.8431",
  "US-ND": "47.5362,-99.7930",
  "US-NE": "41.1289,-98.2883",
  "US-NH": "43.4108,-71.5653",
  "US-NJ": "40.3140,-74.5089",
  "US-NM": "34.8375,-106.2371",
  "US-NV": "38.4199,-117.1219",
  "US-NY": "42.1497,-74.9384",
  "US-OH": "40.3736,-82.7755",
  "US-OK": "35.5376,-96.9247",
  "US-OR": "44.5672,-122.1269",
  "US-PA": "40.5773,-77.2640",
  "US-RI": "41.6772,-71.5101",
  "US-SC": "33.8191,-80.9066",
  "US-SD": "44.2853,-99.4632",
  "US-TN": "35.7449,-86.7489",
  "US-TX": "31.1060,-97.6475",
  "US-UT": "40.1135,-111.8535",
  "US-VA": "37.7680,-78.2057",
  "US-VT": "44.0407,-72.7093",
  "US-WA": "47.3917,-121.5708",
  "US-WI": "44.2563,-89.6385",
  "US-WV": "38.4680,-80.9696",
  "US-WY": "42.7475,-107.2085",
  "US-DC": "38.9072,-77.0369",
};
